import { useEffect } from "react";
import { api } from "@/lib/api";

function getSessionId() {
  try {
    let sid = localStorage.getItem("va_sid");
    if (!sid) {
      sid = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`);
      localStorage.setItem("va_sid", sid);
    }
    return sid;
  } catch {
    return `anon-${Date.now()}`;
  }
}

export default function useVisitTracker(page) {
  useEffect(() => {
    const send = () => {
      const sid = getSessionId();
      api.post("/track/visit", {
        session_id: sid,
        page: page || window.location.pathname,
        referrer: document.referrer || "",
        user_agent: navigator.userAgent.slice(0, 200),
      }).catch(() => {});
    };
    // Throttle: at most one ping per page per 30s
    const key = `va_t_${page || window.location.pathname}`;
    const last = Number(sessionStorage.getItem(key) || 0);
    if (Date.now() - last > 30_000) {
      sessionStorage.setItem(key, String(Date.now()));
      send();
    }
  }, [page]);
}
